var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46875 2.4375L7.57812 3.75H14.375L13.4844 2.4375C13.4375 2.34375 13.2969 2.25 13.1562 2.25H8.79688C8.65625 2.25 8.51562 2.34375 8.46875 2.4375ZM15.3594 1.17188L17.0938 3.75H17.75H20H20.375C20.9844 3.75 21.5 4.26562 21.5 4.875C21.5 5.53125 20.9844 6 20.375 6H20V20.25C20 22.3594 18.3125 24 16.25 24H5.75C3.64062 24 2 22.3594 2 20.25V6H1.625C0.96875 6 0.5 5.53125 0.5 4.875C0.5 4.26562 0.96875 3.75 1.625 3.75H2H4.25H4.85938L6.59375 1.17188C7.0625 0.46875 7.90625 0 8.79688 0H13.1562C14.0469 0 14.8906 0.46875 15.3594 1.17188ZM4.25 6V20.25C4.25 21.0938 4.90625 21.75 5.75 21.75H16.25C17.0469 21.75 17.75 21.0938 17.75 20.25V6H4.25ZM8 9V18.75C8 19.1719 7.625 19.5 7.25 19.5C6.82812 19.5 6.5 19.1719 6.5 18.75V9C6.5 8.625 6.82812 8.25 7.25 8.25C7.625 8.25 8 8.625 8 9ZM11.75 9V18.75C11.75 19.1719 11.375 19.5 11 19.5C10.5781 19.5 10.25 19.1719 10.25 18.75V9C10.25 8.625 10.5781 8.25 11 8.25C11.375 8.25 11.75 8.625 11.75 9ZM15.5 9V18.75C15.5 19.1719 15.125 19.5 14.75 19.5C14.3281 19.5 14 19.1719 14 18.75V9C14 8.625 14.3281 8.25 14.75 8.25C15.125 8.25 15.5 8.625 15.5 9Z",
    fill: "#38539A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.3c9ada85736f67f8374e4b7ce01096c3.svg";
export { ForwardRef as ReactComponent };